// src/pages/CompanyManagement/CompanyList.jsx
import React from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
  Chip,
  Typography,
  InputAdornment
} from '@mui/material';
import {
  Search as SearchIcon,
  Business as BusinessIcon
} from '@mui/icons-material';

const CompanyList = ({ companies, selectedCompany, onSelectCompany, searchTerm, onSearchChange, t }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {/* Search */}
      <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
        <TextField
          fullWidth
          size="small"
          placeholder={t('CompanyManagement.search_companies')}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            )
          }}
        />
      </Box>

      {/* Company List */}
      <List sx={{ flex: 1, overflow: 'auto', p: 0 }}>
        {companies.length === 0 ? (
          <Box sx={{ p: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              {t('CompanyManagement.no_companies_found')}
            </Typography>
          </Box>
        ) : (
          companies.map((company) => (
            <ListItem key={company.id} disablePadding>
              <ListItemButton
                selected={selectedCompany?.id === company.id}
                onClick={() => onSelectCompany(company)}
                sx={{
                  borderLeft: 3,
                  borderColor: selectedCompany?.id === company.id ? 'primary.main' : 'transparent'
                }}
              >
                <ListItemText
                  primary={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <BusinessIcon fontSize="small" color={company.active ? 'primary' : 'disabled'} />
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: selectedCompany?.id === company.id ? 600 : 400,
                          color: company.active ? 'text.primary' : 'text.disabled'
                        }}
                      >
                        {company.name}
                      </Typography>
                    </Box>
                  }
                  secondary={
                    <Box sx={{ mt: 0.5 }}>
                      <Typography variant="caption" color="text.secondary" display="block">
                        {company.tenantId}
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 0.5, mt: 0.5, flexWrap: 'wrap' }}>
                        <Chip
                          label={`${company.userCount || 0} ${t('CompanyManagement.users')}`}
                          size="small"
                          sx={{ height: 20, fontSize: '0.7rem' }}
                        />
                        <Chip
                          label={`${company.locationCount || 0} ${t('CompanyManagement.locations')}`}
                          size="small"
                          sx={{ height: 20, fontSize: '0.7rem' }}
                        />
                        {!company.active && (
                          <Chip
                            label={t('CompanyManagement.inactive')}
                            size="small"
                            color="error"
                            sx={{ height: 20, fontSize: '0.7rem' }}
                          />
                        )}
                      </Box>
                    </Box>
                  }
                />
              </ListItemButton>
            </ListItem>
          ))
        )}
      </List>
    </Box>
  );
};

export default CompanyList;
